import { render, staticRenderFns } from "./BadgetTest.vue?vue&type=template&id=7b960076&scoped=true"
import script from "./BadgetTest.vue?vue&type=script&lang=ts"
export * from "./BadgetTest.vue?vue&type=script&lang=ts"
import style0 from "./BadgetTest.vue?vue&type=style&index=0&id=7b960076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b960076",
  null
  
)

export default component.exports